module.exports = __webpack_public_path__ + "static/img/19.58a99b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/19.png
// module id = PIwY
// module chunks = 0